export default "__VITE_ASSET__Cv5MynsU__"